<template>
  <header class="ex-2-header pb-5" id="header">
    <page-header></page-header>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <h2>Successful Payment</h2>
          <h5 class="mt-4 text-white" v-if="userEmail">
            You will receive an email to confirm your email address <br>
            Kindly, check your inboxes in <b v-if="userEmail">{{userEmail}}</b>
            <br><br>
            <button class="bg-info">
              <router-link :to="{name: 'portal-home'}">Home Page</router-link>
            </button>
          </h5>
          <h5 style="margin-left: 10px" v-if="!userEmail">
            Please Wait<br>
            <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
          </h5>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  components: {
    pageHeader: () => import('./comps/nav/View')
  },
  data () {
    return {
      userEmail: false
    }
  },
  async beforeMount() {
    const urlParams = new URLSearchParams(window.location.search);
    let data = {
      cm:  urlParams.get('cm'),
      st:  urlParams.get('st'),
      amt:  urlParams.get('amt'),
      cc:  urlParams.get('cc'),
      item_name:  urlParams.get('item_name'),
      tx:  urlParams.get('tx'),
    }

    let apiData = {data}
    if (!$store.hasModule('user-mrt-features-api')) {
      let {default: importedModule} = await import('@/modules/user-mrt-features/store/api.js')
      $store.registerModule('user-mrt-features-api', importedModule)
    }

    this.$store.dispatch('user-mrt-features-api/completeMrtRegistration', apiData).then(r => {
      this.userEmail = r.email
    }).catch(e => {
      //$router.push({name: 'portal-home'})
    })
  }
}
</script>

<style>
.lds-roller {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fff;
  margin: -4px 0 0 -4px;
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
